import PropTypes from 'prop-types';

export const travelAgency = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  image: PropTypes.string,
};

export const tour = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  image: PropTypes.string,
  start: PropTypes.string,
  end: PropTypes.string,
  travel_agency: PropTypes.shape(travelAgency).isRequired,
};
export const note = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  created_on: PropTypes.string,
};
export const bidType = {
  id: PropTypes.number.isRequired,
  hotel: PropTypes.object.isRequired,
  start: PropTypes.string,
  end: PropTypes.string,
  suites: PropTypes.number,
  kings: PropTypes.number,
  queens: PropTypes.number,
  suite_rate: PropTypes.number,
  kings_rate: PropTypes.number,
  queens_rate: PropTypes.number,
  notes: PropTypes.arrayOf(PropTypes.shape(note)),
};

export const bookingRequest = {
  id: PropTypes.number.isRequired,
  tour: PropTypes.shape(tour).isRequired,
  bids: PropTypes.arrayOf(PropTypes.shape(bidType)),
};



// WEBPACK FOOTER //
// src/routes/booking/components/BookingPropTypes.js